var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-item",class:{ 'is-active': _vm.is_active },attrs:{"href":_vm.full_path()},on:{"click":function($event){$event.preventDefault();return _vm.open_link()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }